/**
 * JavaScript Document
 * Version: 1.0.0
 * Date: 8/3/2020
 * Author: Liu Changkun
 * Copyright: www.east.net
 */
const PAGE_SIZE = 50;
const PAGE_SIZES = [50, 200, 500];

const page = {
  install: function(Vue) {
    Vue.page = Vue.prototype.$page = {
      size: PAGE_SIZE,
      sizes: PAGE_SIZES
    };
  }
};
export default page;
